import { render, staticRenderFns } from "./DataInputHyperlink.vue?vue&type=template&id=22540168&scoped=true&"
import script from "./DataInputHyperlink.vue?vue&type=script&lang=js&"
export * from "./DataInputHyperlink.vue?vue&type=script&lang=js&"
import style0 from "./DataInputHyperlink.vue?vue&type=style&index=0&id=22540168&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22540168",
  null
  
)

export default component.exports